import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ApiService } from "../../../app/services/api.service";
import { of } from "rxjs";
import {
  debounceTime,
  map,
  distinctUntilChanged,
  filter,
} from "rxjs/operators";
import { fromEvent } from "rxjs";

//import { FuseConfigService } from '@fuse/services/config.service';

@Component({
  selector: "fuse-search-bar",
  templateUrl: "./search-bar.component.html",
  styleUrls: ["./search-bar.component.scss"],
})
export class FuseSearchBarComponent implements OnInit, OnDestroy {
  collapsed: boolean;
  fuseConfig: any;
  @ViewChild("movieSearchInput", { static: false })
  movieSearchInput: ElementRef;
  results: any;
  isSearching: boolean;

  //@Output()
  //input: EventEmitter<any>;

  // Private
  //private _unsubscribeAll: Subject<any>;

  constructor(private _apiService: ApiService) {
    // Set the defaults
    //this.input = new EventEmitter();
    this.collapsed = true;

    // Set the private defaults
    //this._unsubscribeAll = new Subject();
    this.isSearching = false;
    this.results = [];
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {
    setTimeout(() => {
      fromEvent(this.movieSearchInput.nativeElement, "keyup")
        .pipe(
          // get value
          map((event: any) => {
            return event.target.value;
          }),
          // if character length greater then 2
          filter((res) => res.length > 2),
          // Time in milliseconds between key events
          debounceTime(1000),
          // If previous query is diffent from current
          distinctUntilChanged()
          // subscription for response
        )
        .subscribe((text: string) => {
          this.isSearching = true;
          this.searchGetCall(text).subscribe(
            (res) => {
              this.isSearching = false;
              this.results = res;
            },
            (err) => {
              this.isSearching = false;
            }
          );
        });
    });
  }

  searchGetCall(term: string) {
    if (term === "") {
      return of([]);
    }
    return this._apiService.Search(term);
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    //this._unsubscribeAll.next();
    //this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Collapse
   */
  collapse(): void {
    this.collapsed = true;
  }

  /**
   * Expand
   */
  expand(): void {
    this.collapsed = false;
  }

  onSelectItem(item) {
    // Redirect to Corresponding page
  }
}
